import React from 'react'
import { node, object } from 'prop-types'
import Transition from '../components/transition'

const Wrapper = ({ children, location }) => (
  <Transition location={location}>{children}</Transition>
)

Wrapper.propTypes = {
  children: node,
  location: object
}

export default Wrapper
